import type { FaireProductEntity } from "../../entity_types/product";

export const p_mfzddjcp7d: FaireProductEntity = {
  token: "p_mfzddjcp7d",
  type: "product",
  name: "18K STAINLESS STEEL TARNISH FREE  RINGS | 40R119",
  brandToken: "b_9j5az29aau",
  brandName: "JOSSLYN by wall to wall",
  imageUrl:
    "https://cdn.faire.com/fastly/60724b4e7d938a4a58766af4df3c77a3d1cca8f90253b7e8ad7736602e9a646e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4dad4c78470fa2b73535156d5ce8724b99d6f3367d1a5b425b6b413eebcb6eec.jpeg",
    "https://cdn.faire.com/fastly/c704b8ffbd8fd7af89f9b08c934353bf41c52d6f97ec604647b563fb1d5c252a.jpeg",
    "https://cdn.faire.com/fastly/a6d4317339609a75afad4c89cc09aca4c270c913a01ef7d98d011c4ec3c3be89.jpeg",
    "https://cdn.faire.com/fastly/8de9738e0723b14cbffb6d7487789d4aa41da9b887ac9858eff653ab5501be77.jpeg",
    "https://cdn.faire.com/fastly/afe4a16563f045b625531deda2c4a506ae8463f67d496d86716d7e1ca84e95b5.jpeg",
    "https://cdn.faire.com/fastly/5ea4ef47abe33f0ad3e81597d86f3b1637b4ef4ceb652a6a3e5d7ea551bb0f76.jpeg",
    "https://cdn.faire.com/fastly/ef1a60c85c591273fb6b9a8189fcff5d4c36fec5e885543c38cb81b19db4f7b9.jpeg",
    "https://cdn.faire.com/fastly/59083c22fa0a2f8b1df03be9e4598e8a3c184a75f5f35f43422dc24ac6954cb4.jpeg",
  ],
  priceDollars: 8.24,
  description:
    "18K Stainless Steel Tarnish-Free Geometric rings on stainless steel gold Ring are a stunning blend of high end luxury long lasting quality. Featuring shiny gold finish, a beautiful statement ring representing your personality. Durable, tarnish-free 18K gold-plated stainless steel. Each band consist of watch band inspired design.\n\nProduct detail:\nsize: 7\nmaterial:  Stainless Steel\nmetal finish: 18K Real Gold Dipped \nproduct: Lead & Nickel Compliant\ndurability: Tarnish Free, Non-Tarnish\n\nReal Gold Dipped Ring\nStainless Steel Ring\nHypoallergenic Ring\nTarnish-Free Ring\nNon-Tarnish Ring\nWaterproof Ring\nWater Resistant Ring\nSweatproof Jewelry\nFade Resistant Ring\nAnti-oxidation \nLasting Shine \nPVD treated",
  tags: [],
  msrpDollars: 16.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:00.897Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
